import { Stack, SxProps, Typography, TypographyProps } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { Trial_Status } from "@generated/graphql";
import { TRIAL_STATUS_TITLE } from "constants/global";

const TestingStatus = ({
  status,
  sx,
  typographyProps,
}: {
  status: Trial_Status;
  sx?: SxProps;
  typographyProps?: TypographyProps;
}) => (
  <Stack
    direction='row'
    alignItems='center'
    spacing={1}
    sx={{
      borderRadius: 1.5,
      backgroundColor: "base.50",
      color: "text.primary",
      px: "10px",
      py: "6px",
      width: 130,
      ...sx,
    }}>
    <Box
      sx={{
        backgroundColor: `status.${status.toLowerCase()}`,
        width: 12,
        height: 12,
        borderRadius: "50%",
      }}
    />
    <Typography
      variant='body16rg'
      {...typographyProps}>
      {TRIAL_STATUS_TITLE[status]}
    </Typography>
  </Stack>
);

export default TestingStatus;
